<template>
    <div class="row" >
        <div class="col"> <one /> </div>
        <div class="col"> <two /> </div>
        <div class="col"> <three /> </div>
        <div class="col"> <four/> </div>
    </div>
</template>

<script>
import one from './one'
import two from './two'
import three from './three'
import four from './four'
export default {
    name: "second",
    data() {
        return {
            
        };
    },
    methods: {
        
    },
    created() {

    },
    components: {
        one,
        two,
        three,
        four,
    },
};
</script>

<style lang="less" scoped>
    .row {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .col {
            width: 24.8%;
        }  
    }

</style>
